import { Filter, X } from 'lucide-react'
import { Button } from './ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from './ui/sheet'

export default function FilterDrawer({
  open,
  onOpenChange,
  title = "Filter",
  description = "Refine your results using the filters below",
  activeFilterCount = 0,
  onClearFilters,
  buttonLabel = "Filter",
  children
}) {
  return (
    <div className="flex w-full items-center justify-between gap-2">
      {/* Left: active filter indicator and clear — stays left, no layout shift */}
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {activeFilterCount > 0 && onClearFilters && (
          <>
            <div className="hidden sm:flex items-center gap-2 text-sm text-muted-foreground">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-xs text-primary-foreground font-medium">
                {activeFilterCount}
              </span>
              <span>{activeFilterCount === 1 ? 'filter' : 'filters'} active</span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              className="hidden sm:flex gap-1.5 text-muted-foreground hover:text-foreground shrink-0"
            >
              <X className="h-4 w-4" />
              Clear
            </Button>
          </>
        )}
      </div>

      {/* Right: Filters button — aligned with where the tray slides in from */}
      <div className="shrink-0">
        <Sheet open={open} onOpenChange={onOpenChange}>
          <SheetTrigger asChild>
            <Button variant="secondary" size="md" className="gap-2">
            <Filter className="h-4 w-4" />
            {buttonLabel}
            {activeFilterCount > 0 && (
              <span className="sm:hidden ml-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs text-primary-foreground">
                {activeFilterCount}
              </span>
            )}
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-full sm:max-w-md overflow-y-auto">
          <SheetHeader>
            <SheetTitle>{title}</SheetTitle>
            <SheetDescription>{description}</SheetDescription>
          </SheetHeader>
          
          <div className="mt-6 space-y-4">
            {children}
            
            {/* Clear Filters - mobile only (desktop has it outside) */}
            {activeFilterCount > 0 && onClearFilters && (
              <div className="pt-4 border-t sm:hidden">
                <Button
                  variant="outline"
                  onClick={onClearFilters}
                  className="w-full"
                >
                  <X className="h-4 w-4 mr-2" />
                  Clear all filters
                </Button>
              </div>
            )}
          </div>
        </SheetContent>
        </Sheet>
      </div>
    </div>
  )
}
